import CommonVariableTemplates from "./CommonVariableTemplates";

export default CommonVariableTemplates;
